import { defineMessage } from '@lingui/core/macro';

export const rfqWarningTranslations = {
    CouldNotDuplicateAllPcbs: defineMessage({
        message: 'Some PCBs could not be duplicated. Please check the duplicated assembly for missing PCBs.',
    }),
};
